/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Field_Payout_IbanInputs */



/**
* | output |
* | --- |
* | "Payout IBAN" |
*
* @param {Partner_Admin_Field_Payout_IbanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_field_payout_iban = /** @type {((inputs?: Partner_Admin_Field_Payout_IbanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Field_Payout_IbanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auszahlungs-IBAN")
	return /** @type {LocalizedString} */ ("Payout IBAN")
});